import PropTypes from 'prop-types';
import React, { useRef, memo } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { useSpring, animated, config } from '@react-spring/web'
import { COMPANY_ID } from '../../constants';
import { clampAngle, getAngle, usePointer } from '../../utils';
import { Crow, Flag } from '..';
import imageShip from '../../assets/images/ship/ship.png';
import imageCaptain from '../../assets/images/ship/captain.svg';
import imageCompStrix from '../../assets/images/companies/comp-strix.png';
import imageCompTechemy from '../../assets/images/companies/comp-techemy.png';
import imageCompPropine from '../../assets/images/companies/comp-propine.png';
import imageCompTrack from '../../assets/images/companies/comp-track.png';
import imageCompWave from '../../assets/images/companies/comp-wave.png';
import './Ship.scss';

export const Ship = memo(props => {
	const {
		className,
		rotateTo,
		isCaptainAnimated,
		isFirstSailActive,
		isSecondSailActive,
		isThirdSailActive,
		onCompanyHover,
		onCompanyClick,
	} = props;

	// Ship
	const extendedClassName = 'ship-wrapper' + (className ? ' ' + className : '');
	const styleInner = useSpring({
		transform: `rotate(${rotateTo}deg)`,
		config: config.molasses
	});

	// Captain
	const pointer = usePointer();
	const captainRef = useRef();
	let captainPosition = {x: 0, y: 0 };
	if (captainRef.current) {
		const boundingRect = captainRef.current.getBoundingClientRect()
		captainPosition = {
			x: boundingRect.left + window.scrollX,
			y: boundingRect.top + window.scrollY,
		}
	}
	const captainAngle = isCaptainAnimated
		? getAngle(pointer, captainPosition) - 180
		: 0;
	const captainAngleLimited = clampAngle(captainAngle, -30, 20);
	const styleCaptain = useSpring({
		transform: `rotate(${captainAngleLimited}deg)`,
		config: config.molasses
	});

	// Sails
	const styleFirstSail = {
		opacity: isFirstSailActive ? 1 : 0,
		cursor: isFirstSailActive ? 'pointer' : null,
	};
	const styleSecondSail = {
		opacity: isSecondSailActive ? 1 : 0,
		cursor: isSecondSailActive ? 'pointer' : null,
	};
	const styleThirdSail = {
		opacity: isThirdSailActive ? 1 : 0,
		cursor: isThirdSailActive ? 'pointer' : null,
	};
	const handleCompanyClick = (name) => {
		onCompanyClick(name);
	}
	const handleCompanyHover = (name) => {
		onCompanyHover(name);
	}
	const handleCompanyLeave = () => {
		onCompanyHover(null);
	}

	return (
		<div className={extendedClassName}>
			<animated.div className="ship-container" style={styleInner}>
				{/* <Player src={imageShip} className="ship-image" /> */}
				<img src={imageShip} className="ship-image" />
				<div style={styleFirstSail} className="ship-first-sail">
					<div
						className="ship-sail-company-logo-wrapper"
						onClick={() => handleCompanyClick(COMPANY_ID.wave)}
					>
						<img src={imageCompWave} className="ship-sail-company-logo" />
					</div>
					<div
						className="ship-sail-company-logo-wrapper"
						onClick={() => handleCompanyClick(COMPANY_ID.track)}
					>
						<img src={imageCompTrack} className="ship-sail-company-logo" />
					</div>
				</div>
				<div style={styleSecondSail} className="ship-second-sail">
					<div
						className="ship-sail-company-logo-wrapper"
						onClick={() => handleCompanyClick(COMPANY_ID.techemy)}
					>
						<img src={imageCompTechemy} className="ship-sail-company-logo" />
					</div>
					<div
						className="ship-sail-company-logo-wrapper"
						onClick={() => handleCompanyClick(COMPANY_ID.propine)}
					>
						<img src={imageCompPropine} className="ship-sail-company-logo" />
					</div>
				</div>
				<div style={styleThirdSail} className="ship-third-sail">
					<div
						className="ship-sail-company-logo-wrapper"
						onClick={() => handleCompanyClick(COMPANY_ID.strix)}
					>
						<img src={imageCompStrix} className="ship-sail-company-logo" />
					</div>
				</div>
				<animated.img className="ship-captain" style={styleCaptain} src={imageCaptain} ref={captainRef} alt="captain" />
				<Crow className="ship-crow" />
				<Flag className="ship-flag" />
			</animated.div>
		</div>
	);
});

Ship.propsTypes = {
	className: PropTypes.string,
	rotateTo: PropTypes.number,
	isCaptainAnimated: PropTypes.bool,
	isShipAnimated: PropTypes.bool,
	isFirstSailActive: PropTypes.bool,
	isSecondSailActive: PropTypes.bool,
	isThirdSailActive: PropTypes.bool,
	onCompanyHover: PropTypes.func,
	onCompanyClick: PropTypes.func,
};
